import { useContext } from 'react';
import { TableCoreResourceContext } from 'components/table/TableCoreResourceContext';
import { ITableCoreResourceContext } from 'components/table/types';
import { ReportResource } from 'types/domain';

const useCoreTableProps = <T extends ReportResource>() =>
    useContext(TableCoreResourceContext) as ITableCoreResourceContext<T>;

export { useCoreTableProps };
